import { z } from 'zod';

export const TSDCreateMultipartDataSchema = z.object({
  data: z.string().min(1, { message: 'Required' }),
  file: z.any().optional(),
});

export type TSDCreateMultipartData = z.infer<typeof TSDCreateMultipartDataSchema>;
